module.exports = __webpack_public_path__ + "img/clock-black-icon.d8901034.svg";